var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Input = function (_a) {
    var label = _a.label, placeholder = _a.placeholder, type = _a.type, name = _a.name, value = _a.value, onChange = _a.onChange, otherProps = __rest(_a, ["label", "placeholder", "type", "name", "value", "onChange"]);
    return (_jsxs("div", __assign({ className: "fv-row ".concat(label && 'mb-7') }, { children: [label && _jsx("label", __assign({ className: 'required fw-bold fs-6 mb-2' }, { children: label })), _jsx("input", __assign({ placeholder: placeholder, type: type, name: name, value: value, onChange: function (e) { return onChange(e); }, className: 'form-control mb-3 mb-lg-0' }, otherProps))] })));
};
export default Input;
